import {Controller} from "stimulus";
import Cookies from "js-cookie";

export default class extends Controller<HTMLElement> {
  static values = {
    mode: {type: String, default: "system"},
    cookieName: String,
  };

  static targets = ["toggle"];

  declare modeValue: "light" | "dark" | "system";
  declare cookieNameValue: string;

  declare toggleTargets: HTMLButtonElement[];

  connect() {
    this.handleToggleDarkMode();
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", this.handleToggleDarkMode);
  }

  toggle(event) {
    this.toggleTargets.forEach(el => delete el.dataset.active);
    event.currentTarget.dataset.active = "true";

    switch (event.params.mode) {
    case "light":
    case "dark":
      this.modeValue = event.params.mode;
      Cookies.set(this.cookieNameValue, event.params.mode, {sameSite: "strict"});
      break;
    case "system":
      this.modeValue = "system";
      Cookies.remove(this.cookieNameValue);
      break;
    }

    this.handleToggleDarkMode();
  }

  private handleToggleDarkMode = () => {
    if (this.isDarkMode) {
      document.documentElement.dataset.mode = "dark";
    } else {
      delete document.documentElement.dataset.mode;
    }
  };

  private get isDarkMode() {
    return this.cookieValue === "dark" || this.isSystemDarkMode;
  }

  private get isSystemDarkMode() {
    return !this.cookieValue && window.matchMedia("(prefers-color-scheme: dark)").matches;
  }

  private get cookieValue() {
    return Cookies.get(this.cookieNameValue);
  }
}
